import React from "react";

import { Box, Flex, InputField } from "atoms";
import MemoSearch from "assets/icons/Search";
import styled from "styled-components";
// import MemoSearch from "assets/icons/Search";
// import MemoCloseRoundedIcon from "assets/icons/CloseRoundedIcon";

const FlexStyle = styled(Flex)`
  input {
    padding-left: 4rem;
    font-size: 1.6rem;
    border: none;
    color: ${(props) => props.theme.colors.primary[900]};
    background: ${(props) => props.theme.colors.neutral[50]};
  }
`;
/**
 * Render a input box with search icon and conditional close icon inside.
 */
export const SearchBox = ({ onClose, placeholder, ...props }) => {
  return (
    <Box>
      <FlexStyle alignItems="center" width="fit-content">
        <InputField
          noMargin
          {...props}
          autoFocus
          placeholder={placeholder || "Search"}
          isSearchable
          onClose={onClose}
        />
        <Box position="absolute" left="1.5rem" top="1.5rem" color="neutral.400">
          <MemoSearch height="1.8rem" width="1.8rem" />
        </Box>
      </FlexStyle>
    </Box>
  );
};

// function CloseIcon(onClose) {
//   return (
//     <Flex
//       ml="1.2rem"
//       cursor="pointer"
//       color="neutral.600"
//       onClick={onClose}
//       background="transparent"
//     >
//       X
//     </Flex>
//   );
// }
